import React from 'react'

import styled from '@emotion/styled'
import { Color } from '@gousto-internal/citrus-react'
import ArrowIcon from './arrow.svg'

export const Button = styled.button<{ side: string }>(({ side }: { side: string }) => ({
  display: 'none',
  height: 0,
  opacity: 0,

  '@media (min-width: 640px)': {
    position: 'absolute',
    width: '2.5rem',
    height: '2.5rem',
    zIndex: 5,
    borderRadius: '50%',
    top: 'calc(47% -  1.5rem)',
    cursor: 'pointer',
    textAlign: 'center',
    padding: '0.45rem',
    opacity: 0.6,
    border: `1px solid ${Color.White}`,
    outline: 0,
    left: side === 'arrowLeft' ? '2rem' : 'auto',
    right: side === 'arrowRight' ? '2rem' : 'auto',
    transform: side === 'arrowLeft' ? 'rotate(180deg)' : 'rotate(0deg)',
    display: 'block',
    background: '#333D47',
  },
  '@media (min-width: 1280px)': {
    top: 'calc(50% - 1.5rem)',
  },

  '&:focus': {
    outline: 0,
  },

  '&:hover': {
    opacity: 0.9,
  },

  '&::before': {
    content: `url(${ArrowIcon})`,
  },
}))

type ArrowProp = {
  side: 'arrowLeft' | 'arrowRight'
}

type onClick = {
  onClick?: () => void
}

export const Arrow = ({ side, ...props }: ArrowProp) => {
  const stripInvalidHtmlProps = (allProps: Partial<Record<string, unknown>>) => {
    const carouselPropKeys = ['currentSlide', 'slideCount']

    return Object.entries(allProps).reduce(
      (_htmlProps, [key, val]) => ({
        ..._htmlProps,
        ...(!carouselPropKeys.includes(key) && { [key]: val }),
      }),
      {},
    )
  }

  const { onClick } = stripInvalidHtmlProps(props) as onClick

  return (
    <Button
      onClick={onClick}
      type="button"
      data-testid="carouselArrow"
      tabIndex={0}
      side={side}
      data-role="none"
    />
  )
}
